<template>

<div class="row row-meta oddevencol" v-bind:class="[{'complete': rowComplete(), 'contract': isContractRow() }, contractClass, ruleClass ]">

		<div class="col-md-14 control-label first" v-bind:class="{ withcomm : comment != null }">
			<label>{{ title }}</label>
			<p v-html="comment"></p>
		</div>

		<div class="second" v-bind:class="componentSizeClass">
			<div v-show="meta.forced == 0 || (type == 'contract_upload_internal' || type == 'contract_upload_external')">
				<component
					:is="layout"
					:clinic-id="clinicId"
					:current-data="meta"
					:extra-data="extraData"
					:type="type"
					:rule="rule"
					v-on:update="saveMeta">
				</component>
			</div>
		</div>

		<div class="col-md-6 skip" v-show="showForced == true">

			<input type="checkbox" v-on:change="saveMeta()" value="1" v-model="meta.forced" />
			Hoppa över

		</div>

		<div class="col-md-8 cursorhelp" title="Senast ändrat" v-show="showDate == true">
			<div>
				{{ updated() }}
			</div>
		</div>

		<div class="col-md-10 notes" v-show="showComment == true">

			<textarea
				 v-on:change="saveComment()"
				 v-on:keyup="saveComment()"
				 v-model="meta.comment"
				 v-bind:class="{'expand': expand == 1}"
				 class="col-xs-10 form-control"
				 placeholder="Anteckningar">
			</textarea>

		</div>

</div>

</template>

<script>

window._ = require('lodash')

Vue.component('FileUpload', require('./metaParts/FileUpload.vue').default)
Vue.component('FileUploadMulti', require('./metaParts/FileUploadMulti.vue').default)
Vue.component('CheckBox', require('./metaParts/CheckBox.vue').default)
Vue.component('DatePicker', require('./metaParts/DatePicker.vue').default)
Vue.component('Radio', require('./metaParts/Radio.vue').default)
Vue.component('SelectMenu', require('./metaParts/SelectMenu.vue').default)
Vue.component('SelectMenuArray', require('./metaParts/SelectMenuArray.vue').default)
Vue.component('TextBox', require('./metaParts/TextArea.vue').default)
Vue.component('TextInput', require('./metaParts/TextInput.vue').default)
Vue.component('Rule', require('./metaParts/Rule.vue').default)
Vue.component('ContractDownload', require('./metaParts/ContractDownload.vue').default)

export default {

    props: {
	        type: {},
	        layout: {},
	        clinicId: {},
	        rowMeta: {},
	        extraData: {},
	        title: '',
	        rule: {},
	        showForced: {
	        	default: false
	        },
	        showDate: {
	        	default: false
	        },
	        showComment: {
	        	default: false
	        },
	        comment: {
	        	default: ''
	        }
	    },

	   	data () {
        return {

            // meta: this.rowMeta[this.type],
               	expand: 0
        }
    },

	    created: function () {
	    	const self = this

	    	bus.$on('uploaded-file', function (type, file_id) {
	    		if (type == self.type) {
	    			self.meta.has_file = 1

		    		// console.log('got uploaded file in datarow');
                self.saveMeta()
            }
        })

        bus.$on('checkbox-changed', function (type, value) {
	    		if (type == self.type) {
	    			self.meta.value = value

		    		// console.log('got checkbox changed in datarow');
                self.saveMeta()
            }
        })

        bus.$on('radio-changed', function (type, value) {
	    		if (type == self.type) {
	    			self.meta.value = value

		    		// console.log('got checkbox changed in datarow');
                self.saveMeta()
            }
        })

        bus.$on('select-changed', function (type, value) {
	    		if (type == self.type) {
	    			self.meta.value = value

		    		// console.log('got select changed in datarow');
                self.saveMeta()
            }
        })

        bus.$on('text-changed', function (type, value) {
	    		if (type == self.type) {
	    			self.meta.value = value

		    		// console.log('got text changed in datarow');
                self.saveMeta()
            }
        })

        bus.$on('contract-downloaded', function (type, value) {
	    		if (type == self.type) {
	    			self.meta.value = value

		    		// console.log('contract got downloaded');
                self.saveMeta()
            }
        })

        bus.$on('date-changed', function (type, value) {
            if (type == self.type) {
                self.meta.value = value

                // console.log('got date changed in datarow');
                self.saveMeta()
            }
        })
	    },
    computed: {

        	meta () {
        		return this.rowMeta[this.type]
        	},

        	contractClass () {
        		if (this.isContractRow()) {
        			return this.type
        		}

        		return null
        	},
        	ruleClass () {
        		if (this.type == 'rule_reconciliation' || this.type == 'rule_reconciliation_external') {
        			return 'validateRule'
        		}
        		return null
        	},
        	componentSizeClass () {
        		if (this.showForced == true) {
        			return 'col-md-12'
        		}

        		if (this.showDate == true) {
        			return 'col-md-18'
        		}

        		if (this.showComment == true) {
        			return 'col-md-26'
        		}

        		return 'col-md-36'
        	}

    },
	    methods: {

	    	saveMeta: function () {
	    		bus.$emit('set-last-changed')

	    		this.storeMeta()
	    	},

	    	saveComment: function () {
	    		this.storeMeta(true)
	    	},

	    	storeMeta: function (ignoreDate) {
	    		const self = this

	    		const data = { data: self.meta, ignoreDate: ignoreDate }

	    		console.log('saving meta')
	    		console.log(self.meta)

	    		self.$http.post('/clinics/meta/update', data).then((response) => {
	    		    console.log('got meta response')
                console.log(response.body.files)

                if (response.body.forceReload && response.body.forceReload == true) {
                   		bus.$emit('refresh-data', 1)
                   		return
                }

                self.meta.updated_at = response.body.updated_at
                self.meta.files = response.body.files
            }, (response) => {
                console.log(JSON.stringify(response))
            })
	    	},

	    	commentFocus: function (type) {
	    		if (type == 'focus') {
	    			this.expand = 1
	    			return
	    		}

	    		this.expand = 0
	    	},
	    	updated: function () {
	    		if (this.meta.updated_at == this.meta.created_at) {
	    			return ''
	    		}

	    		return this.meta.updated_at
	    	},
	    	rowComplete: function () {
	    		if (this.meta.forced == 1) {
	    			return true
	    		}

	    		if (this.layout == 'rule') {
	    			return this.rule
	    		}

	    		if (this.layout == 'checkBox' && this.meta.value == 1) {
	    			return true
	    		}

	    		if (this.layout == 'selectMenu') {
	    			return true
	    		}

	    		if (this.layout == 'textArea' && this.meta.value != null) {
	    			return true
	    		}

	    		if (this.layout == 'fileUpload' && this.meta.files != null && this.meta.files.length != 0) {
	    			return true
	    		}

	    		if (this.layout == 'fileUploadMulti' && this.meta.files != null && this.meta.files.length != 0) {
	    			return true
	    		}

            if (this.layout == 'datePicker' && this.meta.value != null) {
                return true
            }

	    		return false
	    	},
	    	isContractRow: function () {
	    		const matchingTypes = ['contract_draft_download_internal',
		                            'contract_draft_download_external',
		                            'contract_download_internal',
		                            'contract_download_external',
		                            'contract_upload_internal',
		                            'contract_upload_external']

		        if (matchingTypes.indexOf(this.type) !== -1) {
		        	return true
		        }

		        return false
	    	}

	    }

}
</script>

<style>
	.expand {
		height: 150px;
	}
</style>
